import { render, staticRenderFns } from "./cardMode.vue?vue&type=template&id=2c9ad170&scoped=true"
import script from "./cardMode.vue?vue&type=script&lang=js"
export * from "./cardMode.vue?vue&type=script&lang=js"
import style0 from "./cardMode.vue?vue&type=style&index=0&id=2c9ad170&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9ad170",
  null
  
)

export default component.exports